import { http as axios } from "@/general/utils/http";
import { MailDeliverySetting } from "@/general/store/models";

export default class SettingsApi {
  public static async getMailDeliverySettingRead() {
    const response: MailDeliverySetting = await axios.get(
      `api/user_mail_settings_read`
    );

    return response;
  }

  /**
   *  update mail settings
   *
   * @param point_receipt
   * @param point_balance
   * @param point_expiration_date
   * @param thanks_point_result
   * @param magazine
   * @returns Promise|Error
   */
  public static async postMailDeliverySetting(
    point_receipt: boolean,
    point_balance: boolean,
    point_expiration_date: boolean,
    thanks_point_result: boolean,
    magazine: boolean,
    user: number,
    gb_point_receipt: boolean,
    gb_point_balance: boolean,
    gb_point_expiration_date: boolean,
  ) : Promise <any> {
    const response = await axios.post(`api/user_mail_settings_update`, {
      point_receipt,
      point_balance,
      point_expiration_date,
      thanks_point_result,
      magazine,
      userId: user,
      gb_point_receipt,
      gb_point_balance,
      gb_point_expiration_date
    });
    return response;
  }
}
